import { createFileRoute } from '@tanstack/react-router';

import { AiVisibilityScreen } from '@/screens/onboarding/AiVisibilityScreen';

export const Route = createFileRoute('/_onboarding/onboarding/ai-visibility')({
  component: AiVisibilityScreen,
});
